export { S as SEP, b as addressToHex, c as checkProps, d as decodeHex, a as emptyArray, e as emptyObject, i as isEmpty, j as isEmptyString, l as lowerTrim, h as toLowerCase, g as toUpperCase, t as trim, f as trimAll, m as unwrapJSON, k as unwrapURI, u as upperTrim, n as wrapToString, w as wrapURI } from './shared/minimark.92cd751b.mjs';
import '@polkadot/util';
import '@polkadot/keyring';
import 'slugify';

const addPrefix = (url) => {
  return `ipfs://ipfs/${url}`;
};
const cidRegex = /ipfs\/([a-zA-Z0-9]+)\/?$/;
const extractCid = (ipfsLink) => {
  if (!ipfsLink) {
    return "";
  }
  const match = ipfsLink.match(cidRegex);
  return match ? match[1] : "";
};
const justHash = (ipfsLink) => {
  return /^[a-zA-Z0-9]+$/.test(ipfsLink || "");
};
const unSanitizeIpfsUrl = (url) => {
  return justHash(url) ? addPrefix(url) : url;
};

const createMetadata = (name, description, imageHash, animationUrl = "", attributes = [], externalUrl = "", type = "") => {
  return {
    name,
    description,
    image: unSanitizeIpfsUrl(imageHash),
    animation_url: unSanitizeIpfsUrl(animationUrl),
    attributes,
    external_url: externalUrl || "https://kodadot.xyz",
    type
  };
};

export { addPrefix, createMetadata, extractCid, justHash, unSanitizeIpfsUrl };
